// import httpsCall from '@/services/httpsCall';
import httpsCallForImage from '@/services/httpsCallForImage';

export const uploadFiles = async (file: File) => {
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  const response = await httpsCallForImage.post('/auth/image-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const sshFilesUpload = async (file: File) => {
  if (!file) return;
  const formData = new FormData();
  formData.append('file', file);

  const response = await httpsCallForImage.post('/auth/ssh-upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getFullFileUrl = (filePath: string | undefined | null) => {
  const BASE_URL = import.meta.env.VITE_S3_BASE_URL;
  if (!filePath) return '';
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }
  return `${BASE_URL}${filePath}`;
};

export const getPreviewUrl = (file?: File | string | null): string | undefined => {
  if (!file) return undefined;

  // If already a URL (from backend)
  if (typeof file === 'string') {
    return file;
  }

  // If File object (Formik unsaved file)
  if (file instanceof File) {
    return URL.createObjectURL(file);
  }

  return undefined;
};
